import { useCallback } from 'react'
import {
  useUpdateDocumentVersionSession,
  useUpdateDocumentVersionSessionEvent,
} from '@/services/queries/document_sessions'
import { useTechnicianPageStore } from './useTechnicianPageStore'

export const useEndSession = () => {
  const currentSessionId = useTechnicianPageStore(
    (state) => state.currentSessionId,
  )
  const currentTechnician = useTechnicianPageStore(
    (state) => state.currentTechnician,
  )
  const lastSessionEventId = useTechnicianPageStore(
    (state) => state.lastSessionEventId,
  )

  const { mutateAsync: updateSession, isPending } =
    useUpdateDocumentVersionSession()
  const { mutateAsync: updateEvent } = useUpdateDocumentVersionSessionEvent()

  const endSession = useCallback(
    async (options?: { completeLastEvent?: boolean }) => {
      const completeLastEvent = options?.completeLastEvent ?? true
      if (currentSessionId && currentTechnician) {
        if (lastSessionEventId && completeLastEvent) {
          await updateEvent({
            documentVersionSessionEventId: lastSessionEventId,
            completedTimestamp: new Date().toISOString(),
          })
        }

        await updateSession({
          documentVersionSessionId: currentSessionId,
          completedTimestamp: new Date().toISOString(),
          username: currentTechnician,
        })
      }
    },
    [
      currentSessionId,
      currentTechnician,
      lastSessionEventId,
      updateEvent,
      updateSession,
    ],
  )

  return {
    endSession,
    isPending,
  }
}
